import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { AppState } from '@taxora-business-core/data-access/state/app.state';
import { APP_ROUTES } from '@taxora-business-core/util/constants/app-routes.constant';

export const invitationAuthGuard: CanActivateFn = (route) => {
  const store = inject(Store);
  const router = inject(Router);
  const accessToken = store.selectSnapshot(AppState.accessToken);
  const token = route.paramMap.get('token') ?? '';
  const invitationsUrl = `/${APP_ROUTES.INVITATIONS.ROOT}`;

  if (!accessToken) {
    router.navigate([APP_ROUTES.AUTH.ROOT, APP_ROUTES.AUTH.LOGIN], {
      queryParams: { returnUrl: `${invitationsUrl}?token=${token}` },
    });
    return false;
  }

  router.navigate([APP_ROUTES.INVITATIONS.ROOT], {
    queryParams: { token },
    replaceUrl: true,
  });
  return false;
};
